// extracted by mini-css-extract-plugin
module.exports = {"moreStyles":"TableCell_moreStyles__2zXhI","label":"TableCell_label__2omiq","input":"TableCell_input__3Kz__","icon":"TableCell_icon__14o_Z"};